import classNames from 'classnames'

import { resolveLink } from '~/components/serializers'
import { ComponentTheme } from '~/components/themes'
import type { ButtonVariants } from '~/enums/buttonVariants'

import type { ButtonProps } from '../Button/Button'
import Button, { ButtonVariants as ButtonCompVariants } from '../Button/Button'

import styles from './Ctas.module.css'

export interface CtaProps extends ButtonProps {
  linkText?: string
  buttonStyle: ButtonVariants
}

export interface CtasProps {
  ctas: CtaProps[]
  theme?: ComponentTheme
  stack?: boolean
  center?: boolean
  testID?: string
  iconLeft?: React.JSX.Element
  hideIcon?: boolean
  overrideStyle?: any
  largeGap?: boolean
}

export default function Ctas({
  ctas,
  stack,
  theme = ComponentTheme.primary,
  testID,
  center,
  iconLeft,
  overrideStyle,
  hideIcon = false,
  largeGap = false,
}: CtasProps) {
  const ButtonThemeMap = {
    primary: ButtonCompVariants.primaryDark,
    primaryLight: ButtonCompVariants.primaryLight,
    secondary: ButtonCompVariants.secondaryDark,
    secondaryLight: ButtonCompVariants.secondaryLight,
    textLink: ButtonCompVariants.textLink,
  }

  return (
    <div
      className={classNames(
        styles.base,
        !stack && styles.baseFlex,
        styles[theme],
        center && styles.center,
        largeGap && styles.largeGap
      )}
      data-testid={testID}
    >
      {ctas?.map((cta, i) => {
        return (
          <div key={`button-${i}`} className={styles.cta}>
            <Button
              {...cta}
              iconLeft={!hideIcon ? (iconLeft ? iconLeft : true) : false}
              target={cta.target}
              // eslint-disable-next-line
              // @ts-ignore
              link={cta.link && resolveLink(cta.link)}
              // eslint-disable-next-line
              // @ts-ignore
              variant={
                overrideStyle ? overrideStyle : ButtonThemeMap[cta.buttonStyle]
              }
            >
              <div
                dangerouslySetInnerHTML={{ __html: cta.linkText as string }}
              />
            </Button>
          </div>
        )
      })}
    </div>
  )
}
